// extracted by mini-css-extract-plugin
export var alignCenter = "_8t-d";
export var bannerShown = "_8t-6";
export var buttonContent = "_8t-0";
export var cardList = "_8t-1";
export var centerContent = "_8t-2";
export var chevron = "_8t-3";
export var closePanelButton = "_8t-k";
export var conversationContextContainer = "_8t-l";
export var conversationDetailContainer = "_8t-4";
export var detailWrapper = "_8t-7";
export var dropdownButton = "_8t-e";
export var dropdownTitle = "_8t-9";
export var fullHeight = "_8t-5";
export var hidden = "_8t-a";
export var icon = "_8t-b";
export var mergeSuggestionWrapper = "_8t-m";
export var panel = "_8t-i";
export var portalButtonsWrapper = "_8t-c";
export var right = "_8t-j";
export var tableSummaryContainer = "_8t-8";
export var tableSummaryHeader = "_8t-g";
export var threeDotsButton = "_8t-f";
export var wide = "_8t-h";